import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, reduce, orderBy } from 'lodash';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';

import {
  injectIntl,
  PrintableTable,
} from 'components';

class GroupedListCard extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
  };

  static propTypes = {
    deliveryDate: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    packListInfo: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),

    formatMessage: PropTypes.func.isRequired,
    printHeaderChecked: PropTypes.arrayOf(PropTypes.bool).isRequired,
    checkUpdated: PropTypes.func.isRequired,
  };

  static defaultProps = {
    packListInfo: [],
  };

  getPackListData = () => {
    const { packListInfo } = this.props;
    const { currentUser } = this.context;

    const dataList = packListInfo.map(({ quantity, data, order, packrow }) => {
      return {
        buyerBusinessName: get(order, 'buyer.account.profile.companyName'),
        sellerBusinessName: get(data, 'seller.companyName') || get(order, 'contact.sellerProfile.companyName') || get(currentUser, 'account.profile.companyName'),
        item_name: `${get(data, 'productData.name')}, ${get(data, 'productData.subname')}`,
        item_qty: quantity,
        item_uom: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
      };
    });

    const dataListNoZeroItems = dataList.filter(item => item.item_qty > 0);
    const ordredList = orderBy(dataListNoZeroItems, ['buyerBusinessName', 'sellerBusinessName', 'item_name'], ['asc', 'asc', 'asc']);

    const helper = {};
    // group by item_name and item_uom, then sum item_qty
    const result = reduce(ordredList, (r, o) => {
      const key = `${o.sellerBusinessName}--${o.buyerBusinessName}--${o.item_name}--${o.item_uom}`;
      if (!helper[key]) {
        helper[key] = Object.assign({}, o);
        r.push(helper[key]);
      } else {
        helper[key].item_qty += o.item_qty;
      }

      return r;
    }, []);
    return result;
  }

  updateCheck = (isChecked, index) => {
    const { checkUpdated } = this.props;
    checkUpdated(isChecked, index);
  }

  render() {
    const {
      deliveryDate,
      loading,
      formatMessage,
      printHeaderChecked,
    } = this.props;
    const packListHeader = `${formatMessage('Grouped list for')} ${moment(deliveryDate).format('LLLL')}`;
    const packInfo = this.getPackListData();
    const info = [];
    let currentBuyerBusinessName = packInfo.length > 0 ? packInfo[0].buyerBusinessName : '';
    let currentSellerBusinessName = packInfo.length > 0 ? packInfo[0].sellerBusinessName : '';
    for (let i = 0; i < packInfo.length; i++) {
      if (currentBuyerBusinessName !== packInfo[i].buyerBusinessName ||
          currentSellerBusinessName !== packInfo[i].sellerBusinessName) {
        currentBuyerBusinessName = packInfo[i].buyerBusinessName;
        currentSellerBusinessName = packInfo[i].sellerBusinessName;
        info.push({ item_name: '' });
      }
      info.push(packInfo[i]);
    }
    const totalItemsFields = [
      {
        label: formatMessage('CUSTOMER'),
        name: 'buyerBusinessName',
      },
      {
        label: formatMessage('VENDOR'),
        name: 'sellerBusinessName',
      },
      {
        className: 'highlight',
        colSpan: 2,
        label: formatMessage('A-Z ITEMS'),
        name: 'item_name',
      },
      {
        label: formatMessage('QTY'),
        name: 'item_qty',
      },
      {
        label: formatMessage('PACK-OUT'),
        name: 'item_uom',
      },
    ];

    return (
      <div>
        {
          loading && (
            <div className="print-progress">
              <CircularProgress />
            </div>
          )
        }
        {packListHeader ? (
          <div>
            <div className="packlist-header">{packListHeader}</div>
            <div className="checked-list">
              {
                totalItemsFields.map((field, index) => (
                  <span key={index}>
                    <Checkbox
                      checked={printHeaderChecked[index]}
                      onChange={(e, isInputChecked) => this.updateCheck(isInputChecked, index)}
                    />
                    {field.label}
                  </span>
                ))
              }
            </div>
            <PrintableTable
              checkedArray={printHeaderChecked}
              data={info}
              fields={totalItemsFields}
            />
          </div>) : ''
        }
      </div>
    );
  }
}

const wrappedGroupedListCard = injectIntl(GroupedListCard);
wrappedGroupedListCard.displayName = 'GroupedListCard';

export default wrappedGroupedListCard;
